import { useEffect, useRef } from "react";
import type { Channel, EventData, EventFrame, EventType } from "@agentsaas/protocol";
import type { Subscriber } from "@agentsaas/client-sdk";
import { useServices } from "../app/services";

/** 订阅一个 WS 通道；handlers 可以每次渲染变化（内部用 ref） */
export function useChannel(ch: Channel | null, handlers: Subscriber) {
  const { ws } = useServices();
  const ref = useRef(handlers);
  ref.current = handlers;
  useEffect(() => {
    if (!ch) return;
    return ws.subscribe(ch, {
      onEvent: (e) => ref.current.onEvent?.(e),
      onGap: () => ref.current.onGap?.(),
      onSubscribed: (i) => ref.current.onSubscribed?.(i),
      onBinary: (p) => ref.current.onBinary?.(p),
    });
  }, [ch, ws]);
}

/** 类型收窄：事件 data 的形状 */
export function isEvent<T extends EventType>(e: EventFrame, type: T): e is EventFrame & { type: T; data: EventData<T> } {
  return e.type === type;
}
